<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.account_log")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker(@update="submit")
              CheckDownline.col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(
                ref="username"
                :loading="loading"
                @keyup.enter.native="submit"
                @updateValue="updateTargetId($event)"
              )
              //- CheckDownline.col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(
              //-   ref="action_by"
              //-   text="action_by"
              //-   :loading="loading"
              //-   @keyup.enter.native="submit"
              //-   @updateValue="updateActionBy($event)"
              //- )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.ip_address')" size="sm")
                  b-form-input(
                    type="text"
                    ref="ip_address"
                    v-model="ip_address"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.target_action')" size="sm")
                  b-form-select(
                    size="sm"
                    ref="target_action"
                    v-model="target_action"
                    @change="submit"
                  )
                    option(value="") {{ $t("ui.all") }}
                    option(value="account_unblock") {{ $t("ui.account_unblock") }}
                    option(value="add_account") {{ $t("ui.add_account") }}
                    option(value="add_secondary_full") {{ $t("ui.add_secondary_full") }}
                    option(value="add_sub") {{ $t("ui.add_sub") }}
                    option(value="password_reset") {{ $t("ui.password_reset") }}
                    option(value="password_update") {{ $t("ui.password_update") }}
                    option(value="reset_accumulate_win") {{ $t("ui.reset_accumulate_win") }}
                    option(value="security_disable") {{ $t("ui.security_disable") }}
                    option(value="security_update") {{ $t("ui.security_update") }}
                    option(value="set_authority") {{ $t("ui.set_authority") }}
                    option(value="status_update") {{ $t("ui.status_update") }}
                    option(value="unblock_profile") {{ $t("ui.unblock_profile") }}
                    option(value="update_account") {{ $t("ui.update_account") }}
                    option(value="update_platform") {{ $t("ui.update_platform") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                TableToCSV(v-if="totalRows")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="accesslogList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(datetime)="row")
                    span {{ $moment(row.item.datetime).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(errorTag)="row")
                    span(v-if="row.item.errorTag" :class="row.item.success ? 'text-primary': 'text-danger'") {{ row.item.errorTag.toUpperCase() }}
                  template(v-slot:cell(ipAddress)="row")
                    span {{ row.item.ipAddress }}
                  template(v-slot:cell(targetId)="row")
                    span(v-if="row.item.targetId") {{ row.item.targetId.toUpperCase() }}
                  template(v-slot:cell(actionBy)="row")
                    span(v-if="row.item.actionBy") {{ row.item.actionBy.toUpperCase() }}
                  template(v-slot:cell(targetAction)="row")
                    span {{ $t('ui.' + row.item.targetAction) }}
                  template(v-slot:cell(details)="row")
                    template(v-if="row.item.success && row.item.details")
                      template(v-if="row.item.targetAction != 'reset_accumulate_win'")
                        template(v-if="!['account_unblock','unblock_profile'].includes(row.item.details[0].key)")
                          template(v-if="!['account','add_secondary_full','add_sub'].includes(row.item.details[0].key)")
                            table#innerTable.table.mb-1(v-if="row.item.details")
                              thead
                                tr
                                  th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count != 0 && count < 7")
                                    span {{ $tc("ui." + index, 0) }}
                              tbody
                                tr
                                  td.text-center(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count != 0 && count < 7")
                                    template(v-if="['status_update'].includes(row.item.details[0].key)")
                                      span {{ x }}
                                    template(v-else)
                                      span {{ (index=='status') ? (x==1) ? $t("ui.enable") : $t("ui.disabled") : x=="COCKFIGHT" ? $t("ui.esports2").toUpperCase() : x }}
                              template(v-if="row.item.details[0].value.account_id && row.item.details[0].value.account_id.length < 11")
                                thead
                                  tr
                                    th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count > 6 && count < 14")
                                      span {{ $tc("ui." + index, 0) }}
                                tbody
                                  tr
                                    td.text-center(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count > 6 && count < 14")
                                      template(v-if="['status_update'].includes(row.item.details[0].key)")
                                        span {{ x }}
                                      template(v-else)
                                        span {{ (index=='status') ? (x==1) ? $t("ui.enable") : $t("ui.disabled") : x=="COCKFIGHT" ? $t("ui.esports2").toUpperCase() : x }}
                              template(v-else)
                                thead
                                  tr
                                    th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count > 13 && count < 20")
                                      span {{ $tc("ui." + index, 0) }}
                                tbody
                                  tr
                                    td.text-center(v-for="(x,index,count) in row.item.details[0].value" :key="index" v-if="count > 13 && count < 20")
                                      template(v-if="['status_update'].includes(row.item.details[0].key)")
                                        span {{ x }}
                                      template(v-else)
                                        span {{ (index=='status') ? (x==1) ? $t("ui.enable") : $t("ui.disabled") : x=="COCKFIGHT" ? $t("ui.esports2").toUpperCase() : x }}
                          template(v-else)
                            i.fa(size="sm" @click.stop="row.toggleDetails" @click="showDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  template(v-slot:row-details="row")
                    b-table#innerTable(show-empty :items="row.item.details" :fields="vDfields")
                      template(v-slot:cell(value)="row")
                        template(v-if="row.item.key == 'pt'")
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count < 8")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count < 8")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 7 && count < 16")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 7 && count < 16")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 15 && count < 24")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 15 && count < 24")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 23 && count < 32")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 23 && count < 32")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 31 && count < 40")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 31 && count < 40")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 39 && count < 48")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 39 && count < 48")
                                  span {{ x }}
                        template(v-else-if="row.item.key == 'bl'")
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count < 9")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count < 9")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 8 && count < 18")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 8 && count < 18")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 17 && count < 27")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count > 17 && count < 27")
                                  span {{ x }}
                        template(v-else-if="row.item.key == 'update_platform'")
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index) in row.item.value" :key="index")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index) in row.item.value")
                                  span {{ (index=='status') ? (x==1) ? $t("ui.enable") : $t("ui.disabled") : x }}
                        template(v-else)
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count != 0 && count < 7")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count != 0 && count < 7")
                                  span {{ x }}
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter(v-for="(x,index,count) in row.item.value" :key="index" v-if="count != 0 && count > 6")
                                  span {{ $tc("ui." + index, 0) }}
                            tbody
                              tr
                                td.text-center(v-for="(x,index,count) in row.item.value" :key="index" v-if="count != 0 && count > 6")
                                  span {{ x }}

</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"
import CheckDownline from "@/library/CheckDownline.vue"
import TableToCSV from "@/library/TableToCSV.vue"
import DatePicker from "@/library/DatePicker.vue"

export default {
  components: {
    SubmitButton,
    CheckDownline,
    TableToCSV,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      ip_address: "",
      target_id: "",
      // action_by: "",
      target_action: "",
      accesslogList: [],
      filter: null,
      sortBy: "datetime",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format(
          "YYYY-MM-DD"
        )
      };
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "datetime",
          label: this.$t("ui.date_time"),
          sortable: false,
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "errorTag",
          label: this.$t("ui.status"),
          thClass: "bg-grey",
          thStyle: {
            width: "11%"
          }
        },
        {
          key: "ipAddress",
          label: this.$t("ui.ip_address"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "targetId",
          label: this.$t("ui.username"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "actionBy",
          label: this.$t("ui.action_by"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "targetAction",
          label: this.$t("ui.target_action"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "details",
          label: this.$t("ui.details"),
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        }
      ];
    },
    vDfields() {
      return [
        {
          key: "value",
          label: this.$t("ui.value"),
          thClass: "d-none",
          thStyle: {
            width: "80%"
          }
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    dayList: function() {
      let result = []
      result = list.Table[0]
      return result
    }
  },
  mounted: function() {
    },
  methods: {
    updateTargetId(e) {
      this.target_id = e
    },
    // updateActionBy(e) {
    //   this.action_by = e
    // },
    showDetail: function(item) {
      if(item._showDetails) {
        this.accesslogList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    submit: function() {
      this.$refs.username.$v.$touch()
      if (!this.$refs.username.$v.$invalid) {
        let url = config.accountLogUrl()
        let ipAddress = this.ip_address
        let actionBy = "" //this.action_by.toLowerCase()
        let targetId = this.target_id //(this.target_id !== '') ? this.target_id.toLowerCase() : this.$store.getters.loginID.toLowerCase()
        let targetAction = this.target_action
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sortkey = this.sortBy
        let sorttype = this.direction
        this.loading = true
        this.$store
          .dispatch("log/getLog", {
            url,
            ipAddress,
            actionBy,
            targetId,
            targetAction,
            start_date,
            end_date,
            page_number,
            page_size,
            sortkey,
            sorttype
          })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.status
            if (this.submission.success == true) {
              this.totalRows = response.value[response.value.length - 1].results[0].filteredCount
              response.value.pop()
              this.accesslogList = response.value
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.status
            }
          })
          .catch(response => {
            this.loading = false
            this.totalRows = 0
            this.accesslogList = []
          });
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    }
  }
};
</script>
